import React from 'react'
import { Box, TextField, Button, InputAdornment } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import Grid from '@mui/material/Grid'
import SettingsIcon from '@mui/icons-material/Settings'
import { useTranslation } from 'react-i18next'
import Dialog from './Dialog'
import ResponsiveEditDialog from './EditDialog'
import CustomButton from './CustomButton/CustomButton'

const MyAccount = ({
  deleteBankAccount,
  updateSearch,
  searchTable,
  updateTable,
  setSelectedRows,
  selectedRows,
  handelMOpen,
  onImportClick,
  openAddAccountFromUrl,
  onAddAccountUrlConsumed,
}) => {
  // LAP-733 (GE022) — toolbar i18n
  const { t } = useTranslation('common')
  const showColumn = () => {
    document.getElementById('cus-show-column').click()
  }
  return (
    <>
      <Box bgcolor={'#001b42'} p={1} display="flex">
        <Box p={1}>
          <TextField
            id="filled-basic"
            label={t('mesComptes.search.label')}
            placeholder={t('mesComptes.search.placeholder')}
            size="small"
            sx={{
              color: 'white',

              '& label': {
                color: 'white',
              },
              '& input': {
                color: 'white',
              },
              '& label.Mui-focused': {
                color: 'white',
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            onChange={updateSearch}
          />
        </Box>

        <Button
          onClick={searchTable}
          sx={{
            marginLeft: '5px',
            color: 'white',
            '&:hover': { color: 'black', backgroundColor: 'white' },
          }}
        >
          {t('mesComptes.search.button')}
        </Button>
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} justifyContent="flex-end" pl={3} py={3}>
          <Grid item>
            {/* Bouton unique « Ajouter » : Open banking / Saisie manuelle /
                Import CSV structuré / Import fichier + mapping. L'ancien bouton
                « Importer » séparé a été fusionné dans le menu (onImportClick). */}
            <CustomButton onClick={handelMOpen}>{t('mesComptes.actions.share')}</CustomButton>
            <ResponsiveEditDialog
              updateTable={updateTable}
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
            />
            <Dialog
              updateTable={updateTable}
              openFromUrl={openAddAccountFromUrl}
              onUrlOpenConsumed={onAddAccountUrlConsumed}
              onImportClick={onImportClick}
            />
            <Button
              onClick={deleteBankAccount}
              size="small"
              sx={{
                marginLeft: '15px',
                color: 'white',
                '&:hover': { color: 'black', backgroundColor: 'white' },
              }}
            >
              {t('mesComptes.actions.delete')}
            </Button>
            <Button sx={{ color: 'white' }}>
              <SettingsIcon onClick={showColumn} />
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default MyAccount
